export const PAGE_NAMES = {
    ACCOUNT: 'account',
    ACTIVITY_GOAL: 'activityGoal',
    PROFILE: 'profile',
    PRIVACY: 'privacy',
    GENERAL: 'general',
    NOTIFICATIONS: 'notifications'
};

const pages = {
    [PAGE_NAMES.PRIVACY]: { path: '/usersettings/privacy', localizationKey: 'settings:navbar.privacy', visible: () => true, rest: '/api/settings/privacy' }
};

export const pageList = Object.keys(pages).map(key => Object.assign({ name: key }, pages[key] ));

export default pages;



// WEBPACK FOOTER //
// ./src/UserSettings/pages.js